<template>
  <!-- Three labels this long wrap inside the default `xl`; the card is `w-auto`, so it still shrinks to fit. -->
  <Dialog :title="title" :content="content" size="4xl" data-testid="confirm-dialog" @close="handleKeyboardClose">
    <template #buttons>
      <BaseButton secondary @click="action('saveAsDraft')">Gem som kladde og luk</BaseButton>
      <BaseButton @click="action('cancel')">Fortsæt med at skrive på notatet</BaseButton>
      <BaseButton primary @click="action('close')">Slet indhold og luk</BaseButton>
    </template>
  </Dialog>
</template>

<script>
import Dialog from "~/components/dialogs/Dialog";

export default {
  components: { Dialog },

  props: {
    title: {
      type: String,
      default: "Luk",
    },

    content: {
      type: String,
      default: "Du er ved at lukke vinduet uden at have gemt. Hvad skal der ske?",
    },
  },

  emits: ["close"],

  methods: {
    action(action) {
      this.$emit("close", { action });
    },

    // Dialog reports its own keyboard closes as a boolean, which the caller
    // cannot read: Escape is false; Cmd/Ctrl+Enter confirms the primary
    // button advertises with its ⌘↵ hint.
    handleKeyboardClose(confirmed) {
      this.action(confirmed ? "close" : "cancel");
    },
  },
};
</script>
